<template>
    <el-dialog title="选择课程" :visible.sync="visbleValue" width="800px" top="20px" @close="handleClose">
        <p>提示：一个课程只能关联一个讲解卡，此处只展示未添加讲解卡的课程草稿、已删除状态的课程不展示</p>
        <div class="join_market_table">
            <el-table :data="tableList" @row-click="rowClick" :header-cell-style="{ background: '#F5F7FA', color: '#454D53' }" max-height="700">
                <el-table-column label="" width="50">
                    <template slot-scope="scope">
                        <input type="radio" :disabled="disabledList.includes(scope.row.id)" :checked="scope.row.id == selectId.id" />
                    </template>
                </el-table-column>
                <el-table-column property="img" label="封面" width="200">
                    <template slot-scope="scope">
                        <img :src="scope.row.img" alt="" style="width:67px;height:50px" />
                    </template>
                </el-table-column>
                <el-table-column property="title" label="标题" width="260"></el-table-column>
                <el-table-column property="price" label="价格"></el-table-column>
            </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="sure">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    props: {
        dialogValue: {
            type: Boolean,
            default: false
        },
        // checked: {
        //     type: [Number, String, Boolean],
        //     default: false
        // },
        disabledList: {
            type: Array,
            default: () => []
        },
    },
    created(){
        this.getProductSelect()
    },
    model: {
        prop: 'dialogValue',
        event: 'change'
    },
    computed: {
        visbleValue: {
            set() {

            },
            get() {
                return this.dialogValue
            }
        }
    },
    data() {
        return {
            dialogVisible: false,
            tableList: [],
            selectId: {},
            // keywords: '',
        }
    },
    methods: {
        ...mapActions('explainCard',['getForCardClassListAPI']),
        rowClick(row) {
            if (this.disabledList.includes(row.id)) {
                return
            }
            this.selectId = row
        },
        handleClose() {
            this.$emit('change', false)
        },
        sure() {
            this.$emit('change', false)
            this.$emit('sure', this.selectId)
        },
        // 获取课程列表
        async getProductSelect() {
            let res = await this.getForCardClassListAPI()
            this.tableList = res.data
        },
        // search() {
        //     this.getProductSelect()
        // }
    },
    watch: {
        // checked:{
        //     handler(nval){
        //         this.selectId.id = nval
        //     },
        //     immediate: true
        // },
        dialogValue(news) {
            if (news) {
                // this.getProductSelect()
            }else{
                this.selectId = {}
            }
        }
    }
}
</script>
<style lang="less" scoped>
.join_market_table {
    // height: 600px;
    display: flex;
    flex-direction: column;

    .maket_scrollbar {
        flex: 1 0 auto;
        height: 0;
    }
    .gettinglist_table_search {
        margin-bottom: 12px;
        display: flex;
        flex-wrap: wrap;
        flex-shrink: 0;

        .gettinglist_table_search_con {
            flex-shrink: 0;
        }

        .gettinglist_input_tit {

            .el-input-group__append,
            .el-input-group__prepend {
                background-color: #409eff;
                border-color: #409eff;
                color: #fff;
            }
        }
    }
}
/deep/.el-dialog__body {
    padding: 0 20px ;
}
</style>